import React from 'react';
import {UserLayout} from 'components/layouts/user';
import {ShoppingCart} from './sub-view/shopping-cart';

class MyShoppingCart extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <UserLayout active='MyShoppingCartPage'>
        <h1 className="user-header">Giỏ hàng</h1>
        <ShoppingCart/>
      </UserLayout>
    );
  }
}

export default MyShoppingCart;



// WEBPACK FOOTER //
// ./components/users/MyShoppingCart.jsx